export default __webpack_public_path__ + "static/media/firebase.1ca69ad4.png";